(function () {
  // === CONFIG ===
  const urlParams = new URLSearchParams(window.location.search);
  const debugFromURL = urlParams.get("gar_debug") === "true";

  const config = {
    debug: debugFromURL,
  };

  const log = (...args) => config.debug && console.log("🟢 pro-forma-hyros-tracking:", ...args);

  function getCartTrackingKey(cart) {
    const tx = cart?.token || cart?.id;
    return tx ? `proforma_begin_checkout_${tx}` : null;
  }

  function markBeginCheckoutPublished(cart) {
    const key = getCartTrackingKey(cart);
    if (!key) return false;
    if (sessionStorage.getItem(key)) return false;
    sessionStorage.setItem(key, "1");
    return true;
  }

  async function publishCustomCartData(source) {
    try {
      const res = await fetch("/cart.js");
      if (!res.ok) throw new Error("Cart fetch failed");
      const cart = await res.json();

      if (!markBeginCheckoutPublished(cart)) {
        log("Skipped duplicate custom_cart_data publish", {
          source,
          token: cart?.token || cart?.id || null,
        });
        return;
      }

      if (window.Shopify?.analytics?.publish) {
        Shopify.analytics.publish("custom_cart_data", { cart, source });
        log("Shopify.analytics.publish: custom_cart_data", { source, cart });
      } else {
        log("⚠️ Shopify.analytics.publish unavailable while sending custom_cart_data");
      }
    } catch (err) {
      log("❌ Error publishing custom_cart_data:", err);
    }
  }

  // Send a custom DOM event for Hyros to pick up
  function sendHyrosEmail(email) {
    const detail = { email, ref_url: document.URL };

    // 1️⃣ Hyros listener
    const event = new CustomEvent("hyros_email_captured", { detail });
    window.dispatchEvent(event);
    log("CustomEvent: hyros_email_captured", detail);

    // 2️⃣ Shopify analytics bridge → custom pixels (GTM, etc.)
    if (window.Shopify?.analytics?.publish) {
      Shopify.analytics.publish("email_captured", detail);
      log("Shopify.analytics.publish: email_captured", detail);
    } else {
      log("⚠️ Shopify.analytics.publish not available yet.");
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    const input = document.querySelector("input.email-form-gtZTJcq7vF");
    if (!input) return log("No email field found.");

    // --- Country extractor from current domain ---
    function getCountryFromHostname(hostname) {
      if (!hostname) return "";

      const host = hostname.toLowerCase();

      // Known multi-part TLDs
      const secondLevelTLDs = {
        "co.uk": "UK",        
      };

      // Check multi-part endings first
      for (const tld in secondLevelTLDs) {
        if (host.endsWith(tld)) return secondLevelTLDs[tld];
      }

      // Otherwise use last segment as country
      const last = host.split(".").pop();
      return last.toUpperCase();
    }

    // Use current page domain
    const country = getCountryFromHostname(location.hostname);

    input.addEventListener("blur", (e) => {
      const email = e.target.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;

      // 1) Send to Hyros
      sendHyrosEmail(email);
      publishCustomCartData("email_blur");

      const payload = {
        email,
        tagsToAdd: ["proforma-abandoned"],
        country
      };

      log("Sending payload to proxy:", payload);

      // 2) App Proxy request
      fetch("/apps/proforma-checkout", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          tagsToAdd: ["proforma-abandoned"],
          country,
          subscribe: true
        }),
      })
        .then(async (r) => {
          const text = await r.text();
          let body;
          try { body = JSON.parse(text); } catch { body = text; }
          log("Proxy response:", { status: r.status, body });
        })
        .catch((err) => log("Proxy error:", err));
    });

    log("Ready and listening for email blur.");
  });


})();
